export const capitalizeAndSpace = (input: string, replacements: { [key: string]: string } = {}): string => {
  let result = input;

  // Apply replacements (case-insensitive)
  for (const [key, value] of Object.entries(replacements)) {
    const regex = new RegExp(key, 'gi');
    result = result.replace(regex, value);
  }

  // Original logic: split by underscore, capitalize, and join with spaces
  return result
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
